/* eslint-disable react-hooks/exhaustive-deps */
import { Culture } from "@core/index";
import { FC } from "react";
import ContentLoader from "react-content-loader";

interface IFeedbackItemsSkeletonProps {
}

export const FeedbackItemsSkeleton: FC<IFeedbackItemsSkeletonProps> = () => {
    const { dir } = Culture.getLocale();

    return (
        <div className="feedback-items-skeleton">
            <div className="flex flex-center justify-between issue-tracking">
                <div className="issue-title">
                    <ContentLoader
                        width="100%"
                        height="100%"
                        speed={1}
                        backgroundColor="#ececec"
                        foregroundColor="#949494"
                        rtl={dir === "rtl"}
                    >
                        <rect x="0" y="0" rx="3" ry="3" width="100" height="20" />
                    </ContentLoader>
                </div>
                <div className="button-action flex">
                    <ContentLoader
                        width="100%"
                        height="100%"
                        speed={1}
                        backgroundColor="#ececec"
                        foregroundColor="#949494"
                        rtl={dir === "rtl"}
                    >
                        <circle cx="10" cy="10" r="10" />
                        <circle cx="38" cy="10" r="10" />
                    </ContentLoader>
                </div>
            </div>
            <div className="comment fade">
                <ContentLoader
                    width="100%"
                    height="100%"
                    speed={1}
                    backgroundColor="#ececec"
                    foregroundColor="#949494"
                    rtl={dir === "rtl"}
                >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="15" />
                    <rect x="0" y="23" rx="3" ry="3" width="100%" height="15" />
                </ContentLoader>
            </div>
        </div>
    )
}